import { render } from "./VerifyEmailAfterRegistration.vue?vue&type=template&id=6a882b16&scoped=true"
import script from "./VerifyEmailAfterRegistration.vue?vue&type=script&lang=js"
export * from "./VerifyEmailAfterRegistration.vue?vue&type=script&lang=js"

import "./VerifyEmailAfterRegistration.vue?vue&type=style&index=0&id=6a882b16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a882b16"]])

export default __exports__